import React, { Component } from 'react';
import Sidebar from '../../Components/Sidebar';
import Btn from '../../Components/Btn';
// import TopRoutes from './Components/TopRoutes';
import RecentBookings from './Components/RecentBookings';
import LoadingOverlay from 'react-loading-overlay';
import { connect } from 'react-redux'
import { numberWithCommas } from '../../helpers/formatters';
import { withRouter } from "react-router-dom";
import DateRange from '../../Components/DateRange';
import { bindActionCreators } from 'redux';
import { setDateRange, search, getStats } from '../../store/search/actions';
import { loaderstyle } from '../../config';

class Dashboard extends Component {

    state = {
        syncActive: false,
        dateActive: false
    };

    componentDidMount() {
        if(!this.props.autoSearched) {
            this.search({ resetPage: true });
        }
    }

    search = () => {
        this.props.search({ resetPage: true });
        this.props.getStats();
    };

    toggleDateRangeClasses = () => {
        this.setState({ dateActive: !this.state.dateActive });
    };
    toggleSyncClasses = () => {
        this.setState({ syncActive: !this.state.syncActive });
        setTimeout(() => {
            this.setState({ syncActive: false });
          }, 3000);          
    };

    goToBookings = () => {
        this.props.history.push("/bookings");
    }

    selectRange = (e) => {
        this.props.setDateRange(e.target.value);
    }
  render() {
    let dateClasses = (this.state.dateActive) ? "active" : "";
    let syncClasses = (this.state.syncActive) ? "overlay_visible" : "";
    return (
      <div className="wrapper">
        <Sidebar/>
        <div className="main-panel">
            <div className="page-title">
                <div className="page-title-heading">
                    <h1>Dashboard</h1>
                    <div className={`overlay overlay-sync ${syncClasses}`}>
                        <p>Syncing Bookings and Customers …</p>
                    </div>
                </div>
                <div className="page-title-actions">
                    <form action="#">
                        <div className="form-field">
                            <h5 className="label">Range</h5>
                            <select defaultValue={this.props.date.range} onChange={this.selectRange}>
                                <option value="today">Today</option>
                                <option value="last_30">Last 30 Days</option>
                                <option value="last_month">Last Month</option>
                                <option value="last_2_months">Last 2 Month</option>
                                <option value="last_3_months">Last 3 Month</option>
                            </select>
                        </div>

                        <DateRange 
                            from={this.props.date.from}
                            to={this.props.date.to}
                            toggle={this.toggleDateRangeClasses}
                            classes={dateClasses}
                            />
                    </form>
                </div>
            </div>

            <div className="dashboard-statics">
                <div className="grid-row">

                    <div className="grid-col grid-col_quarter">

                    <LoadingOverlay
                        active={this.props.loading_stats}
                        text="Loading..."
                        spinner
                        styles={loaderstyle}
                    >
                        <div className="statics-box">
                            <h4 className="statics-title">Bookings</h4>
                            <div className="item dib">
                                <h6 className="statics-heading">Bookings</h6>
                                <div className="statics-info">
                                    <p className="bold">{this.props.stats.paid_count}<span className="statics-arrow up"></span></p>
                                </div>
                            </div>
                            <div className="item dib">
                                <h6 className="statics-heading">Revenue</h6>
                                <div className="statics-info">
                                    <p className="bold">{numberWithCommas(this.props.stats.paid_total)} EGP<span className="statics-arrow up"></span></p>
                                </div>
                            </div>
                            <div className="statics-paragraph">
                                <p>{this.props.stats.paid_count} Website (100%)</p>
                                <p>0 Andriod Mobile (0%)</p>
                                <p>0 iOS App (0%)</p>
                            </div>
                            <Btn className="btn simple" onClick={this.goToBookings}>view</Btn>
                        </div>
                        </LoadingOverlay>
                    </div>

                    {/* <div className="grid-col grid-col_quarter">

                        <div className="statics-box">
                            <h4 className="statics-title">Customers</h4>
                            <div className="item">
                                <h6 className="statics-heading tooltip">Customers who Purchased
                                <div className="tooltip-box">
                                    <p>Total customers who bought the total bookings in this period.</p>
                                </div>
                                </h6>
                                <div className="statics-info">
                                    <p className="bold">4200 people<span className="statics-arrow up"></span></p>
                                </div>
                            </div>
                            <div className="item">
                                <h6 className="statics-heading">New Customers</h6>
                                <div className="statics-info">
                                    <p className="bold">1221 people<span className="statics-arrow up"></span></p>
                                </div>
                            </div>
                            <div className="item">
                                <h6 className="statics-heading">Repeated Customers</h6>
                                <div className="statics-info">
                                    <p className="bold">21 people<span className="statics-arrow up"></span></p>
                                </div>
                            </div>
                            <Btn className="btn simple">view</Btn>
                        </div>

                    </div> */}

                    {/* <div className="grid-col grid-col_half">

                        <div className="statics-box">
                            <h4 className="statics-title">Most Sold Routes<a href="#!" className="link">View more</a></h4>
                            <div className="item">
                                <h6 className="statics-heading">Top 8 Routes </h6>
                                <div className="container-outer">
                                    <TopRoutes/>
                                </div>
                            </div>
                        </div>

                    </div> */}

                    {/* <div className="grid-col grid-col_half">

                        <div className="statics-box">
                            <h4 className="statics-title">Last Synced</h4>
                            <div className="container-outer">
                                <SynceTable/>
                            </div>
                        </div>

                    </div> */}
                    
                    <div className="grid-col grid-col_full">
                    <LoadingOverlay
                        active={this.props.loading_search}
                        text="Loading..."
                        spinner
                        styles={loaderstyle}
                    >
                        <div className="statics-box">
                            <h4 className="statics-title">Recent Bookings<a href="#!" className="link" onClick={this.goToBookings}>View more</a></h4>
                            <div className="container-outer">
                                <RecentBookings/>
                            </div>
                        </div>
                    </LoadingOverlay>
                    </div>

                </div>
            </div>

        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
    date: state.search.searchOptions.date,
    stats: state.tickets.stats,
    loading_stats: state.search.loading_stats,
    loading_search: state.search.loading_search,
    autoSearched: state.search.autoSearched,
})

const mapDispatchToProps = (dispatch) => ({
    setDateRange: bindActionCreators(setDateRange, dispatch),
    search: bindActionCreators(search, dispatch),
    getStats: bindActionCreators(getStats, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Dashboard));